/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StagesDialog/view.blocks to change it.
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function StagesDialog({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/EmployeeTable/Content/ActionsAction/Content/Content/EditStagesAction/StagesDialog",
  title
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
 title={title}
/>
{children}
</React.Fragment>)
}